import dynamic from 'next/dynamic';
const SearchInputForm = dynamic(() => import('./SearchInputForm'));

export default SearchInputForm;
